var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOtp.active)?_c('div',[_c('span',{staticClass:"title"},[_vm._v("대기확정코드:")]),_c('strong',{staticClass:"otp"},[_vm._v(_vm._s(_vm.isOtp.notice))])]):_c('div',[_vm._v(_vm._s(_vm.isOtp.notice))])}
var staticRenderFns = []

export { render, staticRenderFns }